import { MARITAL_STATUS_CODES } from "$routes/_lib/constants";
import { MaritalStatus } from "elephant-web/gql";
import React from "react";
import { defineMessage, useIntl } from "react-intl";

const maritalStatusMap = {
  [MaritalStatus.L]: defineMessage({
    id: "maritalStatus.divorced",
    defaultMessage: "Divorced",
  }),
  [MaritalStatus.M]: defineMessage({
    id: "maritalStatus.married",
    defaultMessage: "Married",
  }),
  [MaritalStatus.U]: defineMessage({
    id: "maritalStatus.single",
    defaultMessage: "Single",
  }),
  [MaritalStatus.W]: defineMessage({
    id: "maritalStatus.widowed",
    defaultMessage: "Widowed",
  }),
  [MaritalStatus.Unk]: defineMessage({
    id: "maritalStatus.unknown",
    defaultMessage: "Unknown",
  }),
};

export const useMaritalStatusTranslation = () => {
  const { formatMessage } = useIntl();

  const translateMaritalStatusCode = (maritalStatusCode) => {
    return formatMessage(
      maritalStatusMap[maritalStatusCode] ||
        maritalStatusMap[MARITAL_STATUS_CODES.UNKNOWN],
    );
  };

  const maritalStatuses = React.useMemo(
    () =>
      Object.keys(maritalStatusMap).map((key) => ({
        name: translateMaritalStatusCode(key),
        code: key,
      })),
    [translateMaritalStatusCode],
  );

  return { maritalStatuses };
};
